__turbopack_context__.v({
  "btnBotmRightCurve": "REE0ha_btnBotmRightCurve",
  "btnTopLeftCurve": "REE0ha_btnTopLeftCurve",
  "btnWrapper": "REE0ha_btnWrapper",
});
